import { GetGreenroomMeetingData } from '@/connection/greenroom/get-greenroom-meeting-data';
import { useAppSelector } from '@/store/hooks';
import { getToken } from '@/store/slices/user/selectors';
import { Meeting } from '@/types/greenroom/meeting.types';
import { useEffect, useRef, useState } from 'react';
import useSessionUuidParams from '@/utils/use-session-uuid-params';

type TUseLoadMeetingData = {
  sessionUuid?: string;
};

const useLoadWorkingSessionMeetingData = (props?: TUseLoadMeetingData) => {
  const sessionUuidParams = useSessionUuidParams();
  const sessionUuid = props?.sessionUuid || sessionUuidParams;
  const token = useAppSelector(getToken);
  const fetchingRef = useRef(false);

  const [meeting, setMeeting] = useState<Meeting | null>(null);

  useEffect(() => {
    if (!sessionUuid || !token || fetchingRef.current) return;

    fetchingRef.current = true;
    (async () => {
      try {
        const meeting = await GetGreenroomMeetingData(sessionUuid, token);
        setMeeting(meeting);
      } catch (error) {
        console.error('Error fetching greenroom meeting data', error);
      } finally {
        fetchingRef.current = false;
      }
    })();
  }, [sessionUuid, token]);

  return meeting;
};

export default useLoadWorkingSessionMeetingData;
